import common from "../common";
import MiniSignal from 'mini-signals';
//import isMobile from 'ismobilejs';


export default class Button
{
    constructor(position, css)
    {
    	this.constructPos = position || {};
    	this.constructCss = css || {};

        this.minSize = 70;

    	this.signals = {
            down    : new MiniSignal(),
            up      : new MiniSignal(),
            over    : new MiniSignal(),
            out     : new MiniSignal(),
            click   : new MiniSignal(),
            changed : new MiniSignal(),
            inputFocusIn : new MiniSignal(),
            inputFocusOut : new MiniSignal()
        };

        this.htmlElement = null;
        this.formElement = null;
        this.type = null;
        this.focusOn = false;
        this.centerButtonArea = true;

        this.init();
    }

    init()
    {
    	this.htmlElement = $('<div class="p3-interactiveEntity"></div>');
        this.htmlElement.css(this.constructPos);
        this.htmlElement.css(this.constructCss);
    }

    initButton(label, submit = false)
    {
    	this.type = this.TYPE_BUTTON;
    	this.formElement = $("<button type='" + (submit ? 'submit' : 'button') + "' aria-label='" + label + "'>");
    	this.formElement.css({
            position: 'absolute',
            display: 'inlineBlock',
    		width: '100%',
            height: '100%',
            left: '0px',
            top: '0px',
    		cursor: 'inherit',
            backgroundColor: "transparent",
            backgroundSize: "cover",
            border: "none",
            outline: "none"
    	});
    	this.htmlElement.append(this.formElement);

    	this.addListeners();
    }

    sizeForGEL()
    {
        var wResize = this.htmlElement.width() < this.minSize;
        var hResize = this.htmlElement.height() < this.minSize;

        this.formElement.css({
            'width' :  wResize ? this.minSize + "px" : "100%",
            'height' : hResize ? this.minSize + "px" : "100%",
            'left' : wResize ? ((this.htmlElement.width() - this.minSize) / 2) : '0px',
            'top' : hResize && this.centerButtonArea ? ((this.htmlElement.height() - this.minSize) / 2) : '0px'
        });
    }

    addListeners()
    {
    	if (!isMobile.any)
    	{
            this.formElement.mousedown((event) => this.onMouseDown(event));
            this.formElement.mouseup((event) => this.onMouseUp(event));
            this.formElement.click((event) => this.onMouseClick(event));
            this.formElement.mouseover((event) => this.onMouseOver(event));
            this.formElement.mouseout((event) => this.onMouseOut(event));
        }
        else
        {
            this.formElement.on("touchstart", (event) => this.onMouseDown(event));
            this.formElement.on("touchend", (event) => this.onMouseUp(event));
        }

        this.htmlElement.focusin((event) => this.onFocusIn(event));
        this.htmlElement.focusout((event) => this.onFocusOut(event));

        this.htmlElement.keypress((event) => this.onButtonPress(event));
    }

    destroy()
    {

    }

    initValidationMessage(message = 'Please complete this field first')
    {
        this.validationMessage = $('<div class="p3-validationMessage">' + message + '</div>');
        this.validationMessage.hide();
        this.htmlElement.append(this.validationMessage);
    }

    showValidationMessage(message)
    {
        if(message) this.validationMessage.html(message);
        this.validationMessage.show();
    }

    hideValidationMessage()
    {
        this.validationMessage.hide();
    }

    onMouseDown(e)
    {
    	this.signals.down.dispatch();
    }

    onMouseUp(e)
    {
    	this.signals.up.dispatch();
    }

    onMouseClick(e)
    {
    	this.signals.click.dispatch();
    }

    onMouseOver(e)
    {
    	this.signals.over.dispatch();
    }

    onMouseOut(e)
    {
    	this.signals.out.dispatch();
    }

    onFocusIn(e)
    {
        this.htmlElement.css("outline", "2px solid #5E9ED6");
        this.onMouseOver(null);
        this.focusOn = true;
    }

    onFocusOut(e)
    {
        this.htmlElement.css("outline", "none");
        this.onMouseOut(null);
        this.focusOn = false;
    }

    onButtonPress(e)
    {
        if(e.which === 13 || e.which === 32)
        {
            this.onMouseUp(e);
            console.log('button press');
        }
    }
}

Button.TYPE_BUTTON = 'button';
Button.TYPE_RADIO = 'radio';
Button.TYPE_DROP_DOWN_INPUT = 'drop_down';
Button.TYPE_TEXT_INPUT = 'text_input';
Button.TYPE_TEXT_AREA = 'text_area';
Button.TYPE_CHECKBOX = 'checkbox';

Button.POSITION_TOP_LEFT = {
	left:'0px',
	top:'0px'
};
Button.POSITION_TOP_RIGHT = {
	right:'10px',
    top:'10px',
    zIndex:'1000'
};
Button.POSITION_BOTTOM_LEFT = {
	left:'0px',
	bottom:'0px'
};
Button.POSITION_BOTTOM_RIGHT = {
	right:'0px',
	bottom:'0px'
};